<template>
<div class="page_success">
	<div class="tips">
        <div class="txt">支付成功</div>
		<div class="sub_txt">每天都给自己一点惊喜吧</div>
    </div>
	<div class="actions">
        <div class="action action02" v-if="!is_timescard" @click="goOrderDetail">查看订单</div>
		<div class="action action02" v-else @click="goMyCardList">查看我的次卡</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			order_sn: this.$route.query.order_sn, // 订单号
            from: this.$route.query.from, // 来源（是不是文旅）
			is_timescard: this.$route.query.is_timescard // 是否为购卡订单
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '支付成功',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
        }
        // 订单id
		this.order_sn = this.$route.query.order_sn
    },
	mounted() {
	},
    methods: {
		// 订单详情
		goOrderDetail(){
			var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smartpark/order/detail?order_sn='+that.order_sn
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                if (that.from == 'number') {
                    var url = this.$publicData.numberUrl+'/smartpark/order/detail?order_sn='+that.order_sn
                    window.open(url) 
                } else {
                    that.$router.push({
                        path: '/smartpark/order/detail',
                        query: {
                            order_sn: that.order_sn
                        }
                    })
                }
                
            }
			
		},
		// 查看用户次卡
		goMyCardList(){
			var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/my/smartpark/card'
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                if (that.from == 'number') {
                    var url = this.$publicData.numberUrl+'/my/smartpark/card'
                    window.open(url) 
                } else {
                    that.$router.push({
                        path: '/my/smartpark/card'
                    })
                }
            }
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
